import React from "react";
import Box from "@mui/material/Box";
import Fade from "react-reveal/Fade";
import { useTranslation } from "react-i18next";

const Testimonial1 = () => {
  const { t, i18n } = useTranslation();
  return (
    <Box
      sx={{
        width: 1,

        display: "flex",
        justifyContent: "center",
      }}
    >
      <Fade delay={400}>
        <Box>
          {t("It smells clean!")}
          <Box className="normal" sx={{ fontSize: "14px", pt: 1 }}>
            <div
              dangerouslySetInnerHTML={{
                __html: t(
                  "It is moist to do the job well. <br /> Design and materials used for the packs are decent quality."
                ),
              }}
            />
          </Box>
          <Box sx={{ fontSize: "14px", fontWeight: 100, pt: 1, color: "gray" }}>
            Rac**** {t("from Bronx, NY")}
          </Box>
        </Box>
      </Fade>
    </Box>
  );
};

export default Testimonial1;
